'use client'

import { reportBrowserError } from '@/lib/observability/new-relic-browser'
import { useEffect } from 'react'

export default function GlobalError({ error }) {
  useEffect(() => {
    // The root layout is unavailable here, so instrumentation-client's npm
    // Browser agent is the only reliable browser monitor for this document.
    console.error('Global Application Error:', {
      message: error?.message || 'Unknown error',
      digest: error?.digest,
      stack: error?.stack,
      timestamp: new Date().toISOString(),
    })
    reportBrowserError(error, {
      'error.boundary': 'global',
      ...(error?.digest ? { 'next.error.digest': error.digest } : {}),
    })
  }, [error])

  return (
    <html>
      <head>
        <script src="https://cdn.tailwindcss.com" defer></script>
      </head>
      <body className="flex min-h-screen items-center justify-center px-4 py-16">
        <div className="w-full max-w-md text-center">
          <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-gray-100">
            <svg
              className="h-12 w-12 text-gray-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>

          <h1 className="mb-4 text-2xl font-bold">
            Oops! Something went wrong
          </h1>

          <p className="mb-8 text-gray-600">
            We encountered an unexpected issue, but don&apos;t worry - our team
            has been notified and is looking into it.
          </p>

          <div className="mb-8 flex justify-center">
            <a
              href="/"
              className="rounded bg-blue-600 px-4 py-2 font-semibold text-white hover:bg-blue-700"
            >
              Go to homepage
            </a>
          </div>

          <div className="text-sm text-gray-600">
            <p>
              If you continue experiencing issues, please let us know on our{' '}
              <a
                href="https://discord.gg/VGmzFfjDSH"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                Discord server
              </a>
            </p>
          </div>
        </div>
      </body>
    </html>
  )
}
